// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1105":"4a3f990575d3c43c","1242":"6724ecfd727e7047","1321":"ce7e81598a530a3c","1444":"556d227ac764f02e","6007":"1d958d8ea2709110","6779":"c1a85e053ad05663","8457":"251ce9a5bbe27615","9151":"fe15b9856a3320bb"}[chunkId] + ".js";
};